"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StoreProvider = exports.StoreContext = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
exports.StoreContext = (0, react_1.createContext)({});
const StoreProvider = ({ children, store }) => ((0, jsx_runtime_1.jsx)(exports.StoreContext.Provider, { value: store, children: children }));
exports.StoreProvider = StoreProvider;
